import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="ah-footer mt-auto pt-5 pb-3">
      <div className="container">
        <div className="row gy-4">
          <div className="col-12 col-md-4">
            <img 
              src="/ambarlogo.png" 
              alt="AmbarHome" 
              className="footer-logo mb-3"
            />
            <p className="small footer-muted mb-3">
              Your trusted online shopping destination. Quality products, great
              prices, fast delivery.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm footer-social-btn"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm footer-social-btn"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram" />
              </a>
            </div>
          </div>

          <div className="col-6 col-md-2">
            <h6 className="fw-semibold mb-3">Quick Links</h6>
            <ul className="list-unstyled small mb-0 footer-links">
              <li>
                <Link to="/" className="text-decoration-none">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-decoration-none">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-decoration-none">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-decoration-none">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="fw-semibold mb-3">Customer Service</h6>
            <ul className="list-unstyled small mb-0 footer-links">
              <li>
                <Link to="/faq" className="text-decoration-none">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/shipping-info" className="text-decoration-none">
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-decoration-none">
                  Returns
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-decoration-none">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-12 col-md-3 col-lg-4">
            <h6 className="fw-semibold mb-3">Contact Us</h6>
            <ul className="list-unstyled small mb-0 footer-contact">
              <li>
                <i className="bi bi-envelope-fill me-2" />
                Email:{' '}
                <a href="mailto:ambar.enterpriseltd@gmail.com" className="text-decoration-none">
                  ambar.enterpriseltd@gmail.com
                </a>
              </li>
              <li>
                <i className="bi bi-telephone-fill me-2" />
                Phone: <a href="tel:07843411277" className="text-decoration-none">07843411277</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 pt-3 border-top border-opacity-25 small footer-muted gap-2">
          <span>© {new Date().getFullYear()} AmbarHome. All rights reserved.</span>
          <div className="d-flex gap-3">
            <span>Terms</span>
            <span>Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

